import { DeclineFormKeys } from '../config/form-decline-constants';
import { maxLength } from '../../../../shared/lib/validation/validateMaxLength/max-length';
import { DeclineFormFields } from '../ui/modal-confirm/types';
import { validateForm } from '@shared/lib/validation/validate/validate';

export const validate = (fields: DeclineFormFields) => {
    const { validateField, errors } = validateForm();
    validateField({
        name: DeclineFormKeys.Comment,
        message: maxLength(fields[DeclineFormKeys.Comment], 255),
    });
    return errors;
};
